const pointOfSaleColors: {
  [x: string]: {
    calendarColor: string;
    shiftColor: string;
  };
} = {};

const colors: string[] = [
  'rgba(183, 235, 229, 0.6)',
  'rgba(202, 225, 240, 0.65)',
  'rgba(204, 231, 225, 0.6)',
  'rgba(226, 231, 210, 0.6)',
  'rgba(209, 238, 199, 0.6)',
  'rgba(222, 204, 249, 0.6)',
  'rgba(244, 211, 177, 0.6)',
  'rgba(181, 219, 252, 0.6)',
  'rgba(250, 207, 198, 0.6)',
  'rgba(244, 209, 228, 0.6)',
];

const shiftColors: string[] = [
  'rgba(183, 235, 229, 0.35)',
  'rgba(202, 225, 240, 0.35)',
  'rgba(204, 231, 225, 0.35)',
  'rgba(226, 231, 210, 0.35)',
  'rgba(209, 238, 199, 0.35)',
  'rgba(222, 204, 249, 0.35)',
  'rgba(244, 211, 177, 0.35)',
  'rgba(181, 219, 252, 0.35)',
  'rgba(250, 207, 198, 0.35)',
  'rgba(244, 209, 228, 0.35)',
];

let index = 0; // This variable is not used in the current context, but can be used for future reference.

export const getPointOfSaleColor = (
  pointOfSaleId: string,
  type: 'calendar' | 'shift'
): string => {
  if (pointOfSaleColors[pointOfSaleId]) {
    if (type === 'shift') {
      return pointOfSaleColors[pointOfSaleId].shiftColor;
    }
    return pointOfSaleColors[pointOfSaleId].calendarColor;
  }

  //   const index = Object.keys(pointOfSaleColors).length % colors.length;
  const color = colors[index];
  const shiftColor = shiftColors[index];
  index++;
  pointOfSaleColors[pointOfSaleId] = {
    calendarColor: color,
    shiftColor: shiftColor,
  };

  if (type === 'shift') {
    return shiftColor;
  }
  return color;
};

export const setPointOfSaleColor = (pointOfSaleId: string): void => {
  if (pointOfSaleId in pointOfSaleColors) return;
  const color = colors[index];
  const shiftColor = shiftColors[index];
  index++;

  pointOfSaleColors[pointOfSaleId] = {
    calendarColor: color,
    shiftColor: shiftColor,
  };
};
